import WelcomeScreen from "./WelcomeScreen";
import LoginScreen from "./LoginScreen";
import LoginModeChoiceScreen from "./LoginModeChoiceScreen";
import SignUpScreen from "./SignUpScreen";
import SignUpModeChoiceScreen from "./SignUpModeChoiceScreen";
import ForgotPasswordScreen from "./ForgotPasswordScreen";
import ReferredSignUpScreen from "./ReferredSignUpScreen";
import LoginModeChoiceSocialScreen from "./LoginModeChoiceSocialScreen";
import { createStackNavigator } from "@react-navigation/stack";
import ForgotLoginScreen from "./ForgotLoginScreen";
import React from "react";

const Stack = createStackNavigator();

export default function unauthenticatedNavigationStack() {
  return (
    <>
      <Stack.Screen
        name="Welcome"
        component={WelcomeScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="LoginModeChoice"
        component={LoginModeChoiceScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="Login"
        component={LoginScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="SignUpModeChoice"
        component={SignUpModeChoiceScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="SignUp"
        component={SignUpScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="ReferredSignUp"
        component={ReferredSignUpScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="ForgotPassword"
        component={ForgotPasswordScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="LoginModeChoiceSocial"
        component={LoginModeChoiceSocialScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="ForgotLogin"
        component={ForgotLoginScreen}
        options={{ headerShown: false }}
      />
    </>
  )
}